import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('pnr', /^[0-9a-zA-Z]{6}$/);
